module.exports = __webpack_public_path__ + "img/icon-premium.b616ee7b.png";